/* eslint-disable @typescript-eslint/no-explicit-any */
import { Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { initializeSecurity } from "./utils/securityUtils";

//Font-end
import { PageNotFound } from "./pages/404Page";
import { PageLayout } from "./components/PageLayout";

//Check Time Login
import IdleTimeOutHandler from "./components/IdleTimeOutHandler";

//Backoffice

import { Authen } from "./pages/backend/Authen";
import { UniformSchedule } from "./pages/backend/UniformSurvey/UniformSchedule";
import { UniformSummay } from "./pages/backend/UniformSurvey/UniformSummay";
import { UniformUploadBenefit } from "./pages/backend/UniformSurvey/UniformUploadBenefit";
import { UniformDashboard } from "./pages/backend/UniformSurvey/UniformDashboard";
import Protected from "./Protected";
import { getUserUniformGroup } from "./services/PermissionGroup";
import { UseDesktop } from "./pages/backend/useDesktop";
import { UniformSurvey } from "./pages/font-end/UniformSurvey";
import { ChooseUniform } from "./pages/font-end/ChooseUniform";
import { SuccessfullyChooseUniform } from "./pages/font-end/SuccessfullyChooseUniform";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

import withClearCache from "./ClearCache";
import { UserProfileProvider } from "./contexts/UserProfileContext";

const Pages = (props: any) => {
  useEffect(() => {
    (async () => {
      try {
        // display modal if user has never given consent or version of consent is updated
        const adminUris = ["backoffice"];

        const isAdminPanel = adminUris.some((uri) =>
          window.location.pathname.includes(`/${uri}`)
        );

        if (isAdminPanel) return;
        // const infoUser = await getInfoUsers();
        // const checkPath = window.location.pathname.includes("service");
        // if (infoUser?.codComp1 === "PST" && !checkPath) {
        //   setInfoUsers(false);
        //   return (window.location.href = window.location.origin + "/service");
        // }
      } catch (error) {
        // Silent fail
      }
    })();
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<UniformSurvey />} />
        <Route path="/choose_uniform" element={<ChooseUniform />} />
        <Route path="/successfully" element={<SuccessfullyChooseUniform />} />
        <Route
          path="/backoffice"
          element={
            <Protected
              isAdmin={props.isAdmin}
              role="uniform"
              adminInitialized={props.adminInitialized}
              isCheckingPermission={props.isCheckingPermission}
            >
              <Navigate to="/backoffice/uniform-dashboard" replace />
            </Protected>
          }
        />
        <Route
          path="/backoffice/uniform-dashboard"
          element={
            <Protected
              isAdmin={props.isAdmin}
              role="uniform"
              adminInitialized={props.adminInitialized}
              isCheckingPermission={props.isCheckingPermission}
            >
              <UniformDashboard />
            </Protected>
          }
        />
        <Route
          path="/backoffice/uniform-schedulers"
          element={
            <Protected
              isAdmin={props.isAdmin}
              role="uniform"
              adminInitialized={props.adminInitialized}
              isCheckingPermission={props.isCheckingPermission}
            >
              <UniformSchedule />
            </Protected>
          }
        />
        <Route
          path="/backoffice/uniform-summay"
          element={
            <Protected
              isAdmin={props.isAdmin}
              role="uniform"
              adminInitialized={props.adminInitialized}
              isCheckingPermission={props.isCheckingPermission}
            >
              <UniformSummay />
            </Protected>
          }
        />
        <Route
          path="/backoffice/uniform-upload-benefit"
          element={
            <Protected
              isAdmin={props.isAdmin}
              role="uniform"
              adminInitialized={props.adminInitialized}
              isCheckingPermission={props.isCheckingPermission}
            >
              <UniformUploadBenefit />
            </Protected>
          }
        />
        <Route
          path="/desktop-olny"
          element={
            <Protected
              isAdmin={props.isAdmin}
              role="backoffice"
              adminInitialized={props.adminInitialized}
              isCheckingPermission={props.isCheckingPermission}
            >
              <UseDesktop />
            </Protected>
          }
        />

        <Route path="*" element={<PageNotFound />} />
        <Route path="/auth/:role" element={<Authen />} />
      </Routes>
    </>
  );
};
const Login = () => {
  const { instance } = useMsal();
  localStorage.clear();

  instance.loginRedirect(loginRequest).catch((error) => {
    // Silent fail
  });
  return (
    <>
      <div className="layout-loading">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </>
  );
};

function App() {
  return <ClearCacheComponent />;
}

const MainApp = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminInitialized, setAdminInitialized] = useState(false);
  const [isCheckingPermission, setIsCheckingPermission] = useState(true);
  const [isMounted, setIsMounted] = useState(true);

  // เริ่มต้นระบบความปลอดภัย
  useEffect(() => {
    initializeSecurity();
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  if (localStorage.getItem("Language") === null) {
    localStorage.setItem("Language", "th");
  }

  // Debug function สำหรับ development
  // const handleForceInitialization = () => {
  //   setIsAdmin(true);
  //   setAdminInitialized(true);
  // };

  // Emergency timeout - บังคับให้ initialize หลัง 8 วินาที
  // useEffect(() => {
  //   const emergencyTimeout = setTimeout(() => {
  //     if (!adminInitialized) {
  //       setIsAdmin(false);
  //       setAdminInitialized(true);
  //     }
  //   }, 8000);

  //   return () => clearTimeout(emergencyTimeout);
  // }, [adminInitialized]);

  useEffect(() => {
    const initializeAdminRole = async () => {
      if (!isMounted) return;
      
      try {
        setIsCheckingPermission(true);
        
        // รอให้ sessionStorage โหลดเสร็จ
        await new Promise((resolve) => setTimeout(resolve, 100));
        
        if (!isMounted) return;
        
        // Always check admin permissions on app load
        const adminRole = await getUserUniformGroup();
        
        if (!isMounted) return;
        
        setIsAdmin(adminRole);
        setAdminInitialized(true);
        
        // อัปเดต sessionStorage
        if (typeof window !== 'undefined' && window.sessionStorage) {
          window.sessionStorage.setItem('isUniformAdmin', adminRole ? '1' : '0');
        }
      } catch (error) {
        if (!isMounted) return;
        
        setIsAdmin(false);
        setAdminInitialized(true);
      } finally {
        if (isMounted) {
          setIsCheckingPermission(false);
        }
      }
    };

    if (!adminInitialized && isMounted) {
      // If a previous successful auth set the session flag, trust it to reduce redirects
      const sessionIsAdmin = typeof window !== 'undefined' && window.sessionStorage && window.sessionStorage.getItem('isUniformAdmin') === '1';
      if (sessionIsAdmin) {
        setIsAdmin(true);
        setAdminInitialized(true);
        setIsCheckingPermission(false);
      } else {
        initializeAdminRole();
      }
    }
  }, [adminInitialized, isMounted]);

  // Listen for admin updates from Authen page to keep app state in sync
  useEffect(() => {
    const handler = (e: any) => {
      if (!isMounted) return;
      
      if (e && e.detail && typeof e.detail.isAdmin === 'boolean') {
        setIsAdmin(e.detail.isAdmin);
        setAdminInitialized(true);
        setIsCheckingPermission(false);
        
        // อัปเดต sessionStorage
        if (typeof window !== 'undefined' && window.sessionStorage) {
          window.sessionStorage.setItem('isUniformAdmin', e.detail.isAdmin ? '1' : '0');
        }
      }
    };
    window.addEventListener('uniform-admin-updated', handler as any);
    return () => window.removeEventListener('uniform-admin-updated', handler as any);
  }, [isMounted]);

  if (process.env.REACT_APP_ENV == "test") {
    return (
      <>
        <PageLayout>
          <Pages isAdmin={isAdmin} adminInitialized={adminInitialized} />
        </PageLayout>
      </>
    );
  }

  return (
    <>
      <AuthenticatedTemplate>
        <UserProfileProvider>
          <PageLayout>
            <IdleTimeOutHandler
              onActive={() => {
                // Handle active state
              }}
              onIdle={() => {
                // Handle idle state
              }}
              onLogout={() => {
                // Handle logout state
              }}
              timeOutInterval={process.env.REACT_APP_TIMEOUT_LOGIN} //10 minute
            />
            <Pages 
              isAdmin={isAdmin} 
              adminInitialized={adminInitialized} 
              isCheckingPermission={isCheckingPermission}
            />
          </PageLayout>
        </UserProfileProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

const ClearCacheComponent = withClearCache(MainApp);
export default App;
